import { defineComponent as _defineComponent } from 'vue';
import { computed } from "vue";
import { useFileSources } from "@/composables/fileSources";
export default /*#__PURE__*/ _defineComponent({
    __name: 'FileSourceNameSpan',
    props: {
        uri: null,
        showFullUri: { type: Boolean, default: false }
    },
    setup(__props) {
        const props = __props;
        const { getFileSourceByUri } = useFileSources();
        const fileSource = computed(() => getFileSourceByUri(props.uri));
        const fileSourceName = computed(() => { var _a, _b, _c; return (_b = (_a = fileSource.value) === null || _a === void 0 ? void 0 : _a.label) !== null && _b !== void 0 ? _b : (_c = fileSource.value) === null || _c === void 0 ? void 0 : _c.id; });
        return { __sfc: true, props, getFileSourceByUri, fileSource, fileSourceName };
    }
});
